import _ from 'lodash';
import { GetStaticPaths, GetStaticProps } from 'next';
import {
  ArticlesDetailsPage,
  fetchArticlesDetailsData,
  fetchArticles,
  fetchRelatedArticlesData,
} from 'src/modules/articles';
import fs from 'fs';
import filterPathsListWithOutputChannel from 'src/utils/filterPathsListWithOutputChannel';

export const getStaticPaths: GetStaticPaths = async () => {
  const data = await fetchArticles();
  const articles = data?.articles || [];

  const pathsEn = _.map(articles, ({ slug }) => ({
    params: { slug },
    locale: 'en',
  }));
  const pathsDe = _.map(articles, ({ slug }) => ({
    params: { slug },
    locale: 'de',
  }));

  const pathsList = filterPathsListWithOutputChannel(
    _.map([...pathsEn, ...pathsDe], (p) => `${p.locale}/magazine/${p.params.slug}`)
  );

  fs.writeFileSync('./public/data/paths/magazine_slug.json', JSON.stringify(pathsList, null, 2));

  return { paths: [], fallback: true };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const slug = params?.slug as string;
  const data = await fetchArticlesDetailsData(slug);
  const article = data?.articles?.[0] || null;
  const relatedArticlesData = await fetchRelatedArticlesData(article);
  const relatedArticles = relatedArticlesData?.articles || [];

  return { props: { magazinePage: { article, relatedArticles } } };
};

export default ArticlesDetailsPage;
